import { useCallback } from "react";
import { useMutation } from "@apollo/react-hooks";
import { MY_HR_USERS_WITH_CHANGE_REQUEST } from "my-hr/graphql";

type UseMyHrUsersWithChangeRequestParams = {
  onlyRequested: boolean;
  roleFilters: Record<string, any>;
  onCompleted?: (data: any[]) => void;
  tableData?: {
    searchText?: string;
    page?: number;
    pageSize?: number;
  };
};

export const useMyHrUsersWithChangeRequest = ({
  onlyRequested,
  roleFilters,
  onCompleted = () => {},
  tableData,
}: UseMyHrUsersWithChangeRequestParams) => {
  const paramFilter = { ...roleFilters };
  delete paramFilter.__typeName;

  let queryParams = {
    roleFilters: paramFilter,
    onlyRequested,
    searchText: tableData?.searchText || "",
    page: tableData?.page,
    pageSize: tableData?.pageSize,
  };

  const [loadQueryMutation, { data, loading, error }] = useMutation(
    MY_HR_USERS_WITH_CHANGE_REQUEST,
    {
      variables: queryParams,
    },
  );

  const loadQuery = useCallback(async () => {
    const result = await loadQueryMutation();
    onCompleted(result.data?.usersWithChangeRequest || []);
    return result;
  }, [loadQueryMutation, onCompleted]);

  const result = data?.usersWithChangeRequest || [];

  let requestsCount = 0;
  let usersCount = 0;
  let allUserCount = 0;

  type UserWithChangeRequest = {
    employee: any;
    name: string;
    orgUnit: { name: string };
    jobClass: { name: string };
    requestCount: number;
    _id: string;
    allUserCount: number;
  };

  const parsedResult = result.map((item: UserWithChangeRequest) => {
    requestsCount += item.requestCount;
    usersCount += 1;
    allUserCount = item.allUserCount;
    return {
      employee: item.employee,
      name: item.name,
      orgUnit: item.orgUnit.name,
      jobClass: item.jobClass.name,
      requestCount: item.requestCount,
      _id: item._id,
    };
  });

  return {
    data: parsedResult,
    usersCount: usersCount,
    allUserCount: allUserCount,
    requestsCount,
    loading,
    error,
    loadQuery,
  };
};

export default useMyHrUsersWithChangeRequest;
